<template>
  <Badge :variant="labelColorCoding" :size="small ? 'small' : 'medium'" :label="label" :dot="dot" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BadgeVariant, Badge } from '@tallo/design-system';
import { RentStage } from '@tallo/property';

const props = defineProps<{
  status: RentStage;
  small?: boolean;
  dot?: boolean;
}>();

const statusColorMap = new Map<RentStage, BadgeVariant>([
  [RentStage.INITIAL_CONTACT, 'orange'],
  [RentStage.SHOWING_REQUESTED, 'blue'],
  [RentStage.SHOWING_CONFIRMED, 'green'],
  [RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_RENTER, 'yellow'],
  [RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_OWNER, 'yellow'],
  [RentStage.SHOWING_DECLINED, 'red'],
  [RentStage.SHOWING_COMPLETED, 'green'],
  [RentStage.SHOWING_CANCELLED_BY_RENTER, 'grey'],
  [RentStage.SHOWING_CANCELLED_BY_OWNER, 'grey'],
  [RentStage.STOPPED_PROPERTY_RENTED_OUT, 'green'],
  [RentStage.SHOWING_REQUEST_IGNORED_BY_OWNER, 'grey-dark'],
  [RentStage.APPLICATION_INVITE_SENT, 'yellow'],
  [RentStage.APPLICATION_IN_PROGRESS, 'orange'],
  [RentStage.APPLICATION_COMPLETED, 'blue'],
  [RentStage.APPLICATION_ACCEPTED, 'green'],
  [RentStage.APPLICATION_REJECTED, 'red'],
  [RentStage.NO_LONGER_INTERESTED, 'grey'],
]);

const labelMap = new Map<RentStage, string>([
  [RentStage.INITIAL_CONTACT, 'Initial contact'],
  [RentStage.SHOWING_REQUESTED, 'Showing requested'],
  [RentStage.SHOWING_CONFIRMED, 'Showing confirmed'],
  [RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_RENTER, 'Renter requested showing reschedule'],
  [RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_OWNER, 'You requested showing reschedule'],
  [RentStage.SHOWING_DECLINED, 'Showing declined'],
  [RentStage.SHOWING_COMPLETED, 'Showing completed'],
  [RentStage.SHOWING_CANCELLED_BY_RENTER, 'Renter cancelled the showing'],
  [RentStage.SHOWING_CANCELLED_BY_OWNER, 'You cancelled the showing'],
  [RentStage.STOPPED_PROPERTY_RENTED_OUT, 'Stopped ∙ Property rented out'],
  [RentStage.SHOWING_REQUEST_IGNORED_BY_OWNER, 'You ignored the showing'],
  [RentStage.APPLICATION_INVITE_SENT, 'Application invite sent'],
  [RentStage.APPLICATION_IN_PROGRESS, 'Application In Progress'],
  [RentStage.APPLICATION_COMPLETED, 'Application Completed'],
  [RentStage.APPLICATION_ACCEPTED, 'Application Accepted'],
  [RentStage.APPLICATION_REJECTED, 'Application Rejected'],
  [RentStage.NO_LONGER_INTERESTED, 'No longer interested'],
]);

const labelColorCoding = computed(() => statusColorMap.get(props.status));
const label = computed(() => labelMap.get(props.status));
</script>
